(function () {
  'use strict';

  var popup = null;
  var sizePopup = null;
  var activeVariantId = null;
  var activeSize = '';
  var activeTitle = '';

  function $jq() {
    return window.jQuery_T4NT || window.jQuery;
  }

  function getPopup() {
    if (!popup) popup = document.getElementById('pr_grid_atc_popup');
    return popup;
  }

  function getSizePopup() {
    if (!sizePopup) sizePopup = document.getElementById('pr_grid_size_popup');
    return sizePopup;
  }

  function setPopupContent(btn) {
    var el = getPopup();
    if (!el) return;

    activeVariantId = btn.getAttribute('data-variant-id');
    activeSize = btn.getAttribute('data-size') || '';
    activeTitle = btn.getAttribute('data-product-title') || '';

    var title = el.querySelector('.pr-grid-atc-popup__title');
    var size = el.querySelector('.pr-grid-atc-popup__size');
    var img = el.querySelector('.pr-grid-atc-popup__img');
    var imgWrap = el.querySelector('.pr-grid-atc-popup__img-wrap');
    if (title) title.textContent = activeTitle;
    if (size) size.textContent = activeSize ? 'Size: ' + activeSize : '';

    var imgSrc = btn.getAttribute('data-product-image') || '';
    if (!imgSrc) {
      var card = btn.closest('.pr_grid_item');
      var cardImg = card && card.querySelector('.product-image img, .product-image .nt_bg_lz.lazyloadt4sed');
      if (cardImg) {
        imgSrc = cardImg.getAttribute('src') || cardImg.getAttribute('data-src') || cardImg.getAttribute('data-bgset') || '';
        if (imgSrc && imgSrc.indexOf(' ') > -1) imgSrc = imgSrc.split(' ')[0];
      }
    }
    if (img && imgWrap) {
      if (imgSrc) {
        img.src = imgSrc;
        img.alt = activeTitle;
        imgWrap.style.display = 'block';
      } else {
        img.removeAttribute('src');
        imgWrap.style.display = 'none';
      }
    }
  }

  function markSelected(btn) {
    var wrap = btn.closest('.pr-size-hover') || btn.closest('.pr-grid-size-popup__content');
    if (!wrap) return;
    wrap.querySelectorAll('.pr-size-hover__btn.is-selected').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
  }

  function openAtcPopup(btn) {
    var jq = $jq();
    if (!jq || !jq.magnificPopup) return;

    setPopupContent(btn);
    markSelected(btn);

    jq.magnificPopup.open({
      items: { src: '#pr_grid_atc_popup', type: 'inline' },
      removalDelay: 300,
      mainClass: 'mfp-fade pr-grid-atc-mfp',
      closeBtnInside: true,
      callbacks: {
        open: function () {
          document.body.classList.add('pr-grid-atc-open');
        },
        close: function () {
          document.body.classList.remove('pr-grid-atc-open');
        }
      }
    });
  }

  function openSizePopup(sizeHoverEl) {
    var jq = $jq();
    var shell = getSizePopup();
    if (!jq || !jq.magnificPopup || !shell) return;

    var inner = sizeHoverEl.querySelector('.pr-size-hover__inner');
    var content = shell.querySelector('.pr-grid-size-popup__content');
    if (!inner || !content) return;

    content.innerHTML = inner.outerHTML;

    jq.magnificPopup.open({
      items: { src: '#pr_grid_size_popup', type: 'inline' },
      removalDelay: 300,
      mainClass: 'mfp-fade pr-grid-size-mfp',
      closeBtnInside: true,
      callbacks: {
        open: function () {
          document.body.classList.add('pr-grid-size-open');
        },
        close: function () {
          document.body.classList.remove('pr-grid-size-open');
        }
      }
    });
  }

  function closePopup() {
    var jq = $jq();
    if (jq && jq.magnificPopup) jq.magnificPopup.close();
  }

  function triggerGokwikCheckout() {
    var checkoutBtn = document.querySelector('.mini_cart_footer .gokwik-checkout button, .gokwik-checkout button');
    if (typeof window.onCheckoutClick === 'function' && checkoutBtn) {
      window.onCheckoutClick(checkoutBtn);
      return;
    }
    window.location.href = '/checkout';
  }

  function addToCart(variantId, onDone, options) {
    options = options || {};
    var url = window.t_cartadd_url || '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || 'Could not add to cart');
        }
        if (!options.skipCartUi && window.geckoShopify && typeof window.geckoShopify.onCartUpdate === 'function') {
          var id = data.items && data.items[0] ? data.items[0].product_id : 19041994;
          window.geckoShopify.onCartUpdate(1, 1, id);
        }
        if (!options.skipCartUi) {
          document.body.dispatchEvent(new CustomEvent('CartUpdateSuccess'));
        }
        if (typeof onDone === 'function') onDone(data);
      })
      .catch(function (err) {
        if (window.geckoShopify && typeof window.geckoShopify.CreatNotices === 'function') {
          window.geckoShopify.CreatNotices(err.message || 'Error adding to cart');
        }
      });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var mobileBtn = e.target.closest('.pr-grid-mobile-atc');
      if (mobileBtn) {
        e.preventDefault();
        e.stopPropagation();
        var card = mobileBtn.closest('.pr_grid_item');
        var sizeHover = card && card.querySelector('.pr-size-hover');
        if (sizeHover) openSizePopup(sizeHover);
        return;
      }

      var sizeBtn = e.target.closest('.pr-size-hover__btn:not(.is-soldout):not([disabled])');
      if (sizeBtn) {
        e.preventDefault();
        e.stopPropagation();

        var fromMobilePopup = !!sizeBtn.closest('#pr_grid_size_popup');
        if (fromMobilePopup) {
          closePopup();
          setTimeout(function () {
            openAtcPopup(sizeBtn);
          }, 320);
        } else {
          openAtcPopup(sizeBtn);
        }
        return;
      }

      var atcBtn = e.target.closest('.js_pr_grid_atc');
      if (atcBtn) {
        e.preventDefault();
        if (!activeVariantId) return;
        atcBtn.classList.add('loading');
        addToCart(activeVariantId, function () {
          atcBtn.classList.remove('loading');
          closePopup();
        });
        return;
      }

      var bnBtn = e.target.closest('.js_pr_grid_bn');
      if (bnBtn) {
        e.preventDefault();
        if (!activeVariantId) return;
        bnBtn.classList.add('loading');
        closePopup();
        addToCart(
          activeVariantId,
          function () {
            bnBtn.classList.remove('loading');
            triggerGokwikCheckout();
          },
          { skipCartUi: true }
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
